import {
  actionTypes,
  buySuccessType,
  buyTypes,
  currentBuyType,
  priceType,
} from "./purchaseTypes";

const initialState: purchaseStateType = {
  billingAmounts: [],
  minimalBillingAmount: 0,
  billingRedirect: "",

  balance: null,
  balanceLoading: false,
  topPlace: 0,
  hiddenRest: null,
  onlineRest: null,
  pinnedRest: null,
  premiumRest: null,
  place: null,

  pricesPremium: [],
  velvetCatalog: null,
  pricesTop: [],
  pricesHidden: [],
  pricesOnline: [],
  pricesUp: [],

  buyType: null,
  buyId: null,
  currentBuy: {} as currentBuyType,
  buyLoading: false,
  buySuccess: "Never",
  boosts: 0,
  boostUsed: false,

  bonusPrice: 0,
  bonusCooldown: "",
  bonusUsed: false,
};

type purchaseStateType = {
  billingAmounts: Array<number>;
  minimalBillingAmount: number;
  billingRedirect: string;

  balance: number | null;
  balanceLoading: boolean;
  topPlace: number;
  hiddenRest: string | null;
  onlineRest: string | null;
  pinnedRest: string | null;
  premiumRest: string | null;
  place: number | null;

  pricesPremium: Array<priceType>;
  velvetCatalog: any;
  pricesTop: Array<priceType>;
  pricesHidden: Array<priceType>;
  pricesOnline: Array<priceType>;
  pricesUp: Array<priceType>;

  buyType: null | buyTypes;
  buyId: null | number;
  currentBuy: currentBuyType;
  buyLoading: boolean;
  buySuccess: buySuccessType;
  boosts: number;
  boostUsed: boolean;

  bonusPrice: number;
  bonusCooldown: string;
  bonusUsed: boolean;
};

const purchaseReducer = (state = initialState, { type, payload }: any) => {
  switch (type) {
    case actionTypes.SET_BILLING_AMOUNTS:
      return {
        ...state,
        billingAmounts: payload,
        minimalBillingAmount: Math.min.apply(Math, payload),
      };
    case actionTypes.SET_BILLING_REDIRECT:
      return {
        ...state,
        billingRedirect: payload,
      };

    case actionTypes.SET_BALANCE:
      return {
        ...state,
        balance: payload,
      };
    case actionTypes.SET_BALANCE_LOADING:
      return {
        ...state,
        balanceLoading: payload,
      };

    case actionTypes.SET_PREMIUM_PRICES:
      return {
        ...state,
        pricesPremium: payload,
      };
    case actionTypes.SET_VELVET_CATALOG:
      return {
        ...state,
        velvetCatalog: payload,
      };
    case actionTypes.SET_TOP_PRICES:
      return {
        ...state,
        pricesTop: payload,
      };
    case actionTypes.SET_HIDDEN_PRICES:
      return {
        ...state,
        pricesHidden: payload,
      };
    case actionTypes.SET_ONLINE_PRICES:
      return {
        ...state,
        pricesOnline: payload,
      };
    case actionTypes.SET_UP_PRICES:
      return {
        ...state,
        pricesUp: payload,
      };

    case actionTypes.SET_CURRENT_BUY:
      return {
        ...state,
        currentBuy: payload,
      };
    case actionTypes.SET_BUY_LOADING:
      return {
        ...state,
        buyLoading: payload,
      };
    case actionTypes.SET_BUY_SUCCESS:
      return {
        ...state,
        buySuccess: payload,
      };
    case actionTypes.SET_SOME_PREMIUMS:
      return {
        ...state,
        hiddenRest: payload.hiddenRest,
        onlineRest: payload.onlineRest,
        pinnedRest: payload.pinnedRest,
        premiumRest: payload.premiumRest,
        place: payload.place || state.place
      };
    case actionTypes.SET_BOOSTS:
      return {
        ...state,
        boosts: payload,
      };
    case actionTypes.REDUCE_BOOSTS:
      return {
        ...state,
        boosts: state.boosts > 0 ? state.boosts - payload : 0,
      };
    case actionTypes.SET_BOOST_USED:
      return {
        ...state,
        boostUsed: payload,
        place: 1,
      };
    case actionTypes.SET_BONUS_PRICE:
      return {
        ...state,
        bonusPrice: payload.bonus,
        bonusCooldown: payload.cooldown,
      };
    case actionTypes.SET_BONUS_USED:
      return {
        ...state,
        bonusUsed: payload,
      };
    default:
      return state;
  }
};

export default purchaseReducer;
